"use client";

/**
 * NewForm DS hover icon — a filled square for "stop generating".
 * On hover the square contracts slightly, the same gesture a physical
 * stop key gives under a finger.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function StopIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <rect
        className="g a-halt"
        x="6.6"
        y="6.6"
        width="10.8"
        height="10.8"
        rx="2.6"
        fill="currentColor"
      />
    </HoverIconSvg>
  );
}
